import { useEffect, useState } from "react";
import { Asset, AssetGroup } from "../models/asset";

function useUptimeSidebar(allTags: AssetGroup[], allAssets: Asset[]) {
    const [searchQuery, setSearchQuery] = useState("");

    const [selectedTags, setSelectedTags] = useState<Set<string>>(new Set<string>());

    const [tagWithAssets, setTagWithAssets] = useState<{ [tagId: string]: { assets: Asset[], assetsIds: string[], selectedAssetIds: Set<string> } }>();

    useEffect(() => {
        const tagWithAssets: { [tagId: string]: { assets: Asset[], assetsIds: string[], selectedAssetIds: Set<string> } } = {};
        allTags.forEach((tag) => {
            tagWithAssets[tag.id] = {
                assets: allAssets.filter((asset) => asset.groupIds?.includes(tag.id)),
                assetsIds: allAssets.filter((asset) => asset.groupIds?.includes(tag.id)).map((asset) => asset.id),
                selectedAssetIds: new Set<string>()
            };
        });
        setTagWithAssets(tagWithAssets);
        addAllTags();
    }, [allTags, allAssets]);

    const [viewMode, setViewMode] = useState("assets");
    const getSearchLabel = (viewMode: string) => {
        switch (viewMode) {
            case "assets":
                return "Buscar veículos";
            case "tags":
                return "Buscar grupos";
        }
    }

    const handleFilter = (term: string) => {
        setSearchQuery(term);
    }

    const getVehicleTypeCount = (vehicleType: string): number => {
        return allAssets
        .filter((asset) => {
            if(!searchQuery) return true;
            if(viewMode === "assets") return asset.chassis?.toLowerCase().includes(searchQuery.toLowerCase());
            return true;
        })
        .filter((asset) => asset.type === vehicleType).length;
    }

    const addTag = (tagId: string, filteredAssetIds?: string[]) => {
        setSelectedTags(prev => new Set([...prev, tagId]));
        setTagWithAssets(prev => {
            const assetIdsToSelect = filteredAssetIds || prev![tagId].assetsIds;
            return {
                ...prev,
                [tagId]: {
                    ...prev![tagId],
                    selectedAssetIds: new Set(assetIdsToSelect)
                }
            };
        });
    };

    const removeTag = (tagId: string) => {
        setSelectedTags(prev => {
            const newSet = new Set(prev);
            newSet.delete(tagId);
            return newSet;
        });
        setTagWithAssets(prev => ({
            ...prev,
            [tagId]: {
                ...prev![tagId],
                selectedAssetIds: new Set()
            }
        }));
    };

    const addAllTags = (filteredTagsWithAssets?: { [tagId: string]: string[] }) => {
        const tagsToAdd = allTags.filter(el => el.id);
        setSelectedTags(new Set(tagsToAdd.map((tag: AssetGroup) => tag.id)));

        setTagWithAssets(prev => {
            const updated = { ...prev };
            tagsToAdd.forEach((tag: AssetGroup) => {
                const assetIdsToSelect = filteredTagsWithAssets?.[tag.id] || prev![tag.id].assetsIds;
                updated[tag.id] = {
                    ...prev![tag.id],
                    selectedAssetIds: new Set(assetIdsToSelect)
                };
            });
            return updated;
        });
    };

    const removeAllTags = () => {
        setSelectedTags(new Set());
        setTagWithAssets(prev => {
            const updated = { ...prev };
            allTags.forEach((tag: AssetGroup) => {
                updated[tag.id] = {
                    ...prev![tag.id],
                    selectedAssetIds: new Set()
                };
            });
            return updated;
        });
    };

    return {
        tagWithAssets,
        setTagWithAssets,
        viewMode,
        setViewMode,
        getSearchLabel,
        handleFilter,
        selectedTags,
        getVehicleTypeCount,
        searchQuery,
        setSearchQuery,
        addTag,
        removeTag,
        addAllTags,
        removeAllTags,
    }
}

export default useUptimeSidebar;